<template>
    <div v-if="whiteBrandDomains.some(d => domain.includes(d))" class='white_dns'>
        <v-card
            width="400" 
            class="mx-auto rounded-xl py-6 px-8 deep-purple lighten-5 signup__form__card"
            elevation="3"
            :class="$vuetify.breakpoint.mdAndUp ? 'mt-5' : ''"
        >
            <v-card-title class="primary--text text-center">
                <p>
                    <b>
                        ¿Has olvidado tu contraseña?
                    </b>
                </p>
            </v-card-title>
            <v-card-text class="pb-0" v-if="!success"> 
                <v-form id="password-reset-form">
                    <v-text-field 
                        label="Email" 
                        prepend-inner-icon="mdi-account-circle" 
                        v-model="email" 
                        outlined  
                        background-color="#FFFFFF"    
                        type="email" 
                        :error="error_email"                                                                                                                      
                    />
                    <p v-if="error" class="red--text">{{error}}</p>
                </v-form>
            </v-card-text>                                                
            <v-card-actions class="justify-center my-2 py-0" v-if="!success">
                <v-btn large rounded elevation="0" class="px-6 mb-2 white--text font-weight-bold" color="#00BFFF" :loading='loading' @click="passwordReset">
                    Restablecer Contraseña
                </v-btn>
            </v-card-actions>
            <v-card-text v-if="success">
                Le hemos enviado un correo electrónico con las instrucciones para restablecer la contraseña. <br/>
                Si no lo ha recibido, por favor revise su carpeta de correo no deseado. <br/>
                En caso contrario, póngase en contacto con nosotros si no lo recibe en unos minutos.
            </v-card-text>
            <v-card-actions class="justify-center my-2 py-0">
                <router-link :to="{ name: 'login' }">
                    Inicia sesión 
                </router-link>
                &nbsp;con tus credenciales 
            </v-card-actions>
        </v-card>
    </div>
  <div v-else>
    <app-header-public :transparentHeader="false"/>
    <section>
        <v-container 
            fluid 
            class="fill-height pb-16"
            :class="$vuetify.breakpoint.lgAndUp ? 'signup__background' : ''"
        >
            <v-row align="center" justify="space-around">
                <v-col lg="6" xl="5" sm="12" xs="12" md="6">
                    <v-row justify="center">
                        <v-col :cols="$vuetify.breakpoint.lgAndUp ? 8:12" >
                            <v-container :fluid="true" :class="{ 'text-center mt-12': $vuetify.breakpoint.smAndDown }">
                                <div :class="{ 'mx-12': $vuetify.breakpoint.sm }">
                                    <v-img v-if="$vuetify.breakpoint.mdAndUp" src="/logo-primary.png" max-width="162px" class="mb-12" />
                                    <p class="text-h6 text-uppercase primary--text">Contabilidad automatizada</p>
                                    <h1 :class="{'text-h3':$vuetify.breakpoint.mdAndUp,'text-h5':$vuetify.breakpoint.smAndDown}" class="primary--text font-weight-bold mt-5 mb-3">
                                        ¡Hola! Soy Inmatic. Tu robot contable.
                                    </h1>
                                    <p class="mb-2 grey--text text--darken-3">
                                        Descubre como liberar la carga de trabajo y el tiempo que te requiere picar facturas
                                        de forma simple y ágil.
                                    </p>
                                    <h2 class="mb-2">¿Qué consigues con nuestra prueba gratuita?</h2>
                                    <ul class="mb-3 grey--text text--darken-3">
                                        <li>
                                            Aprovecha una solución basada en inteligencia artificial para reducir a la mitad el
                                            tiempo de contabilización de tus facturas.
                                        </li>
                                        <li>
                                            Aumenta la eficacia de tu gestoría creando un modelo de trabajo escalable.
                                        </li>
                                        <li>
                                            Motoriza de principio a fin el proceso contable.
                                        </li>
                                    </ul>
                                </div>
                            </v-container>
                        </v-col>
                    </v-row>
                </v-col>

                <v-col 
                    :order="$vuetify.breakpoint.mdAndUp ? '' : 'first'" 
                    lg="6" xl="5" sm="12" xs="12" md="6" 
                    class="signup__form__column"
                >
                    <div :class="{'mx-5':$vuetify.breakpoint.mdAndDown}">
                        <v-card
                            width="400" 
                            class="mx-auto rounded-xl py-6 px-8 deep-purple lighten-5 signup__form__card"
                            elevation="3"
                            :class="$vuetify.breakpoint.mdAndUp ? 'mt-5' : ''"
                        >
                            <v-card-title class="primary--text text-center">
                                <p>
                                    <b>
                                        ¿Has olvidado tu contraseña?
                                    </b>
                                </p>
                            </v-card-title>
                            <v-card-text class="pb-0" v-if="!success"> 
                                <v-form id="password-reset-form">
                                <v-text-field 
                                    label="Email" 
                                    prepend-inner-icon="mdi-account-circle" 
                                    v-model="email" 
                                    outlined  
                                    background-color="#FFFFFF"    
                                    type="email" 
                                    :error="error_email"                                                                                                                      
                                />
                                <p v-if="error" class="red--text">{{error}}</p>
                                </v-form>
                            </v-card-text>                                                
                            <v-card-actions class="justify-center my-2 py-0" v-if="!success">
                                <v-btn large rounded elevation="0" class="px-6 mb-2 white--text font-weight-bold" color="#00BFFF" :loading='loading' @click="passwordReset">
                                    Restablecer Contraseña
                                </v-btn>
                            </v-card-actions>
                            <v-card-text v-if="success">
                            Le hemos enviado un correo electrónico con las instrucciones para restablecer la contraseña. <br/>
                            Si no lo ha recibido, por favor revise su carpeta de correo no deseado. <br/>
                            En caso contrario, póngase en contacto con nosotros si no lo recibe en unos minutos.
                            </v-card-text>
                            <v-card-actions class="justify-center my-2 py-0">
                                <router-link :to="{ name: 'login' }">
                                    Inicia sesión 
                                </router-link>
                                &nbsp;con tus credenciales 
                            </v-card-actions>
                        </v-card>
                        <v-img src="/auth-form-curve.png" class="signup__form__curve" v-if="$vuetify.breakpoint.mdAndUp" />
                    </div>
                </v-col>

            </v-row>
        </v-container>
    </section>
    
    <app-footer-public/>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AppHeaderPublic from "@/components/layout/AppHeaderPublic";
import AppFooterPublic from "@/components/layout/AppFooterPublic";

export default {
  name: 'PasswordResetPage',
  components: {
    AppHeaderPublic,
    AppFooterPublic,    
  },
  data() {
    return {
        loading: false,
        email: '',
        error:'',
        success: false,
        domain: window.location.origin,
        whiteBrandDomains: [
            'docuxtract.docunecta.com',
            'gscan.glasof.com',
            'portal.oxigendc.com',
            'app.novantiaeconomistas.es',
            'app.gestoriamoro.com'
        ],
    }
  },
  metaInfo() {
    return {
        title: this.pageTitle(),
        titleTemplate: null,
        meta: [
            {name: 'description', content: '¿Has olvidado tu contraseña? Restablece tu contraseña en Inmatic de forma segura. Recupera el acceso a tu cuenta en segundos.'},
            {name: 'robots', content: 'noindex'},
        ],  
    }
  },
  computed: {
    error_email(){
      this.error = '';
      if (this.email) {
        let re = /^[\w-\.]+@([\w-]+\.)+[\w]{2,3}$/        
        return !re.test(this.email);
      } else {        
        return false;
      }
    },
  },
  methods: {
    pageTitle() {
        if (this.whiteBrandDomains.some(d => this.domain.includes(d))) {
            return 'Restablecer contraseña'
        } else {
            return 'Restablecer contraseña - Inmatic'
        }
    },
    async passwordReset() {      
      if (this.email && !this.error_email) {
        if (this.whiteBrandDomains.some(d => this.domain.includes(d))) {
            this.error = "Contacte con soporte para restablecer su contraseña."
        } else { 
            this.loading = true;
            try {
                const resp = await this.passwordResetUser({
                    email: this.email,                
                });
                console.log(resp);
                this.loading = false;
                if ('error' in resp['data']) {
                    this.error = "Se ha producido un error. Contacte con soporte para restablecer su contraseña."
                }
                else {
                    this.success = true;        
                }
            } catch (error) {
                this.loading = false;
                this.error = error.message;
            }
        }
      }
      else {
        this.error = "Email inválido"
      }    
    },
    ...mapActions(["passwordResetUser"]), 
  }
}
</script>

<style scoped>
    .signup__form__column {
        position: relative;
    }
    .signup__form__card {
        z-index: 1;
        font-family: "Roboto",sans-serif !important;
    }
    .v-text-field--outlined fieldset {
      color: rgba(0, 0, 0, 0) !important;
    }
    p {
        overflow-wrap: normal;
        word-break: normal;
    }
    ul{
        padding: 0px;
    }
    ul > li {
      margin: 0;
      list-style-type: "\003E";
      list-style-position: inside;
    }
    ul > li::marker {
      color: var(--v-secondary-base);
      font-weight: bold;
    }
    @media screen and (min-width: 600px) {
        .signup__form__curve {
            position: absolute;
            top: -5%;
            left: 50%;
            transform: translate(-50%, 0);
        }
    }
    @media screen and (min-width: 960px) {
        .signup__form__curve {
            top: 0;
            max-width: 450px;
        }
        .signup__background {
            background-image: url('/auth-form-rectangle-bg.png');
            background-position: bottom right;
        }
    }
    .footer  {
      margin-top:0px !important;
    }
    .white_dns {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>
